import React, { useState } from 'react';
import './Courses.css';
import { coursesData } from '../../utils/coursesData';
import { FaCheckCircle, FaArrowRight, FaClock, FaChartLine } from 'react-icons/fa';
import { colors } from '../../utils/colors';
import { getImagePath } from '../../utils/pathUtils';

const Courses = () => {
  const [activeCard, setActiveCard] = useState(null);
  
  const handleCardHover = (id) => {
    setActiveCard(id);
  };
  
  return (
    <section id="courses" className="courses-section">
      <div className="container">
        <div className="section-header">
          <h2>Our Courses</h2>
          <p>Empower your career with our industry-focused courses</p>
        </div>
        
        <div className="courses-grid">
          {coursesData.map(course => (
            <div 
              key={course.id} 
              className={`course-card ${activeCard === course.id ? 'active' : ''}`}
              onMouseEnter={() => handleCardHover(course.id)}
              onMouseLeave={() => handleCardHover(null)}
            >
              <div className="card-image">
                <img src={getImagePath(course.image)} alt={course.title} />
                <div className="overlay"></div>
              </div>
              
              <div className="card-content">
                <h3>{course.title}</h3>
                <p>{course.description}</p>
                
                <div className="course-meta">
                  <div className="meta-item">
                    <FaClock className="meta-icon" />
                    <span>{course.duration}</span>
                  </div>
                  <div className="meta-item">
                    <FaChartLine className="meta-icon" />
                    <span>{course.level}</span>
                  </div>
                </div>
                
                <div className="course-features">
                  <h4>What you'll learn:</h4>
                  <ul>
                    {course.features.slice(0, 4).map((feature, index) => (
                      <li key={index}>
                        <FaCheckCircle className="feature-icon" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                
                <a href="#contact" className="course-cta">
                  <span>Enroll Now</span>
                  <FaArrowRight className="arrow-icon" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Courses;
